<template>
  <IngredientCardPopover>
    <template #items>
      <IngredientCardPopoverItem
        v-for="section in sections"
        :key="section.title"
        :title="section.title"
        :items="section.items"
      />
    </template>
    <div class="flex flex-col justify-between -my-7 w-[140px] shrink-0">
      <img
        src="https://cdn.shopify.com/s/files/1/1209/5722/files/card-chia.webp"
        alt="Chia seeds"
        width="229"
        class="object-cover"
      >
      <img
        src="https://cdn.shopify.com/s/files/1/1209/5722/files/card-flax.webp"
        alt="Flax seeds"
        width="229"
        class="object-cover"
      >
    </div>
  </IngredientCardPopover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import IngredientCardPopover from './ingredient-card-popover.vue'
import IngredientCardPopoverItem from './ingredient-card-popover-item.vue'
import { ingredientCards, visibleSections, type Page } from '@/utils/ingredient-cards'

export interface Props {
  page?: Page
}

const props = defineProps<Props>()

const sections = computed(() => visibleSections(ingredientCards.find(card => card.id === 3)!.sections, props.page))
</script>
